module.exports = __webpack_public_path__ + "img/header-weddingRingsFrameSettings@2x.77172b1.jpg";